import { DataTable } from "@frui.ts/dataviews/dist";
import type { ColumnDefinition } from "@frui.ts/dataviews/dist/dataTypes";
import type { ViewComponent } from "@frui.ts/views/dist";
import { preventDefault, registerView } from "@frui.ts/views/dist";
import { IconType } from "@edaz/edazkit/Icon";
import Button from "@edaz/edazkit/Button/index";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import { observer } from "mobx-react-lite";
import { Select } from "@frui.ts/bootstrap";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import React from "react";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import type UserRole from "../../../entities/userRole";
import UserRolesViewModel from "../../../viewModels/users/users/userRolesViewModel";

export const UserRolesView: ViewComponent<UserRolesViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<UserRole>[] = [
    {
      title: vm.translateAttribute("role", "name"),
      property: "role",
      valueFormatter: props => props.item.role.name,
    },
  ];

  if (vm.allowWrite) {
    columns.push({
      cellClassName: "text-align-end",
      valueFormatter: props => (
        <ButtonToolbar className="d-inline-flex">
          <Button
            iconLeft={IconType.Trash}
            size="sm"
            variant="danger"
            className="rounded"
            onClick={() => vm.onDelete(props.item)}
          />
        </ButtonToolbar>
      ),
    });
  }

  return (
    <>
      <LoaderOverlay loading={vm.busyWatcher.isBusy}>
        {vm.possibleToAddNewRole && vm.allowWrite && (
          <Form className="mt-4" onSubmit={preventDefault(vm.onAddClick)}>
            <h4 className="mb-2">{vm.translate("add")}</h4>
            <Form.Row>
              <FormGroup as={Col} target={vm} property="role">
                <FormLabel>{vm.translateAttribute("userRole", "role")}</FormLabel>
                <Select items={vm.allowedRoles} mode="item" textProperty="name" />
              </FormGroup>
              <Form.Group as={Col}>
                <Button size="sm" style={{ marginTop: "2.2rem" }} type="submit">
                  {vm.translateGeneral("add")}
                </Button>
              </Form.Group>
            </Form.Row>
          </Form>
        )}
        <h4 className="mt-4 mb-4">{vm.name}</h4>
        <DataTable columns={columns} items={vm.items} itemKey="id" className="table table-full table-striped" />
        {vm.busyWatcher.isBusy && vm.items.length === 0 && (
          <div className="bg-white mt-n2 mb-4 py-3 border-bottom text-muted full-width">{vm.translateGeneral("loading")}</div>
        )}
        {!vm.busyWatcher.isBusy && vm.items.length === 0 && (
          <div className="bg-white mt-n2 mb-4 py-3 border-bottom text-muted full-width">{vm.translate("empty")}</div>
        )}
      </LoaderOverlay>
    </>
  );
});

registerView(UserRolesView, UserRolesViewModel);
